// 老的文件，兼容老的功能。

/*****
 * 菜单及路由操作工具方法集合
 */

//生成菜单
export const getSystemMenu = (arr, parentKey) => {
  let pageKeyObject = {};
  let menus = { childrenKeys: [] }; //菜单变量加上子项键的数组
  let btnlist = {}; //接口
  let btnType = ['RESOURCE_INNER_LINK', 'RESOURCE_BLANK_LINK'];
  console.log(arr,'---arr')
  arr.forEach(ele => {
    if (btnType.indexOf(ele.type) > -1) {
      let { text, type, customId } = ele;
      btnlist[customId] = { text, type };
    } else {
      let { type, text, customId, url, icon, items } = ele;
      let item = { type, text, customId, url, icon };
      let key = customId;
      if (items && items.length > 0) {
        let obj = getSystemMenu(items, key);
        pageKeyObject = { ...pageKeyObject, ...obj.pageKeyObject };
        if (obj.menus.childrenKeys.length > 0) {
          Object.assign(item, obj.menus);
        }
        if (Object.keys(obj.btnlist).length > 0) {
          Object.assign(btnlist, obj.btnlist);
        }
      }
      pageKeyObject[key] = parentKey;
      menus.childrenKeys.push(key);
      menus[key] = item;
    }
  });
  return { menus, pageKeyObject, btnlist };
};
//获取菜单指定节点内容
export const getSystemMenuNode = (menus, key_index, key) => {
  let arr = [key];
  do {
    arr.push(key_index[key]);
  } while (menus[arr[arr.length - 1]] === "");
  arr = arr.reverse();
  var obj = menus[arr[0]]; //第一城没有children
  let i = 1;
  while (i < arr.length) {
    obj = obj[arr[i]];
    i++;
  }
  return obj;
};
//根据页面url获取页面在菜单树的键
export const getKeyByUrl = url => {
  let arr = window.location.href.split("#");
  let page = arr[arr.length - 1];
  page = page.replace(/\/+/g, "_");
  return page;
};
//根本页面路由获取页面的菜单键
export const getPageKeyByPath = (path, pageAuthKeyObject) => {
  let arr = path.split("/");
  if (!pageAuthKeyObject) {
    pageAuthKeyObject = window.systemInfo.pageAuthKeyObject;
  }
  let pageKey = arr.join("_");
  let i = 0; //限制循环次数防止死循环
  //查找当前路由在页面权限路由对象中的键,如果未查找到返回路由的第一个关键字
  while (!pageAuthKeyObject[pageKey] && arr.length > 1 && i < 100) {
    i++;
    if (arr[arr.length - 1] !== "") {
      arr[arr.length - 1] = "";
    } else {
      arr.pop();
    }
    pageKey = arr.join("_");
  }
  return pageKey;
};
//通过页面的键获取页面对应的菜单键
export const getPageMenuKeyByPageKey = (pageKey, pageAuthKeyObject) => {
  if (pageAuthKeyObject === null) {
    pageAuthKeyObject = window.systemInfo.pageAuthKeyObject;
  }
  let i = 0; //限制循环次数防止死循环
  let pageAuthKey = pageKey;
  //查找当前路由对应的 菜单页键
  while (pageAuthKeyObject.hasOwnProperty(pageAuthKey) && i < 100) {
    i++;
    pageAuthKey = pageAuthKeyObject[pageAuthKey];
  }
  return pageAuthKey;
};
//通过页面对应菜单键获取当前页面在菜单中所有上级菜单的键
export const getMenuKeysByPageMenuKey = (pageMenuKey, pageMenusKeyObject) => {
  if (pageMenusKeyObject === null) {
    pageMenusKeyObject = window.systemInfo.pageKeyObject;
  }
  let menus = [];
  let i = 0; //限制循环次数防止死循环
  let menuKey = pageMenuKey;
  //查找菜单页及菜单页对应的模块的键
  while (pageMenusKeyObject.hasOwnProperty(menuKey) && i < 100) {
    i++;
    menus.push(menuKey);
    menuKey = pageMenusKeyObject[menuKey];
  }
  menus.reverse();
  return menus;
};
//根据路由获取页面菜单选中项
export const getSelectMenusByRouter = path => {
  let pageAuthKeyObject = window.systemInfo.pageAuthKeyObject;
  let pageMenusKeyObject = window.systemInfo.pageKeyObject;
  let pageKey = getPageKeyByPath(path, pageAuthKeyObject);
  //查找当前路由对应的 菜单页键
  let pageMenuKey = getPageMenuKeyByPageKey(pageKey, pageAuthKeyObject);
  //查找菜单页及菜单页对应的模块的键
  let menus = getMenuKeysByPageMenuKey(pageMenuKey, pageMenusKeyObject);
  return menus;
};
